<div class="termini-testo">
  @if (versione(); as v) {
    <p class="versione">{{ 'termini.versione' | transloco: { versione: v } }}</p>
  }

  <div class="documento" [innerHTML]="testoMostrato()"></div>
</div>
